import React, { useEffect, useState } from "react";
import InputAHSF from "../../../Components/InputAHSF";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import DateInput from "../../../Components/DateInput";
import { useDispatch, useSelector } from "react-redux";
import {
  GetPersonalInformation,
  SetPersonalInformation,
} from "../../../Redux/Reducers/PersonalInformation";
import {
  GetAllAI_CountryOfResidence,
  GetAllAI_Governorate,
  GetAllAI_Nationality,
} from "../../../Redux/Reducers/DropDownApplicationInformation";
import DROWBDOWNLIST from "../../../Components/DrowbDownList";
import { UpdateAI_Co_ApplicantNamesByEmail } from "../../../Redux/Reducers/CoApplicantNames";
import { setRefreshTable } from "../../../Redux/Reducers/VariousVariables";
import $ from "jquery";
import moment from "moment-timezone";
import { decryptToken } from "../../../Services/Account/EncryptionParams";
import { useParams } from "react-router-dom";
import { GetAllTG_PalestinianGovernoratesName } from "../../../Redux/Reducers/ProjectInformationPage/InformationAboutTheTargetGroupOfTheProject/DropDowntPalestinianGovernorates";

const PersonalInformation = (props) => {
  const AppGuid = useParams();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      ApplicationInformation: state.ApplicationInformation.ApplicationInformation,
      PersonalInformation: state.PersonalInformation.PersonalInformation,
      PersonalInformationLoading:
        state.PersonalInformation.loadingPersonalInformation,
      AI_Nationality: state.dropDownApplicationInformation.AI_Nationality,
      AI_CountryOfResidence:
        state.dropDownApplicationInformation.AI_CountryOfResidence,
      AI_Governorate: state.dropDownApplicationInformation.AI_Governorate,
      DropDownPalestinianGovernoratesName:
        state.DropDownPalestinianGovernoratesName
          .DropDownPalestinianGovernoratesName,
      loadingAI_Governorate:
        state.DropDownPalestinianGovernoratesName.loadingAI_Governorate,
        loadingAI_CountryOfResidence:
        state.DropDownPalestinianGovernoratesName.loadingAI_CountryOfResidence,
      ApplicationInformationValidationPage:
        state.ApplicationInformationValidationPage
          .ApplicationInformationValidationPage,
      ActiveRound: state.ApplicationInformation.ActiveRound,
    };
  });

  const [PersonalInformationUpdateData, setPersonalInformationUpdateData] =
    useState({
      ...state.PersonalInformation,
    });
  const [secoundName, setsecoundName] = useState(
    state.PersonalInformation?.fatherName
  );
  //[,]
  //to get all dropdown data

  useEffect(() => {
    dispatch(GetAllAI_Nationality());
    dispatch(GetAllAI_CountryOfResidence());

    

    //to get PersonalInformation data by guid from localstorge or params

    dispatch(
      GetPersonalInformation(
        localStorage.getItem("aI_ApplicationInformationId") ||
          decryptToken(AppGuid.AppGuid)
      )
    );
  }, []);

// useEffect(()=>{
//   dispatch(
//     GetAllAI_Governorate(state.PersonalInformation?.aI_CountryOfResidenceId)
//   );
// },[state.PersonalInformation?.aI_CountryOfResidenceId])

  //[,]
  //to assigin data to state after api ends loding
  useEffect(() => {
    if (!state.PersonalInformationLoading) {
      setPersonalInformationUpdateData({ ...state.PersonalInformation });
      setsecoundName(state.PersonalInformation?.fatherName);
    }
  }, [state.PersonalInformationLoading]);
  //[,]
  //to assigin data to reducer on any change on  PersonalInformationUpdateData state
  useEffect(() => {
    dispatch(SetPersonalInformation({ ...PersonalInformationUpdateData }));
  }, [PersonalInformationUpdateData]);



  // Dispatch an action to fetch all governorates based on the selected country of residence

  useEffect(() => {
    dispatch(
      GetAllAI_Governorate(state.PersonalInformation?.aI_CountryOfResidenceId)
    );
    
  }, [state.PersonalInformation?.aI_CountryOfResidenceId]);

  //[,]
  //this function to update data on AI_Co_ApplicantNames by email after update on gender or phonenumber
  const updateOnCoNamesGender = async (model) => {
    const saved = await dispatch(UpdateAI_Co_ApplicantNamesByEmail(model));
    if (saved) {
      dispatch(setRefreshTable());
    }
  };

  let shouldDisableFields = ""
  if(state.ApplicationInformation?.aI_ApplicationStatusId){
    shouldDisableFields = !(
      state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
        state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
        state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
        !window.location.href.includes("manager")
    );
  }
console.log(secoundName,"Sssswdwdwdsssdwd");

  
//to render html
  let html = (
    <>
      <div className="form-grid">
        <InputAHSF
          fieldsName="firstName"
          show={true}
          disabled={true}
          defaultValue={state.PersonalInformation?.firstName}
        />
        <InputAHSF
          fieldsName="secondName"
          show={true}
          disabled={shouldDisableFields || secoundName}
          defaultValue={state.PersonalInformation?.fatherName}
          onChange={(e) => {
            setPersonalInformationUpdateData({
              ...PersonalInformationUpdateData,
              fatherName: e.target.value, // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ApplicationInformationValidationPage
              ? state.ApplicationInformationValidationPage.includes(
                  "secondName"
                )
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <InputAHSF
          fieldsName="lastName"
          show={true}
          disabled={true}
          defaultValue={state.PersonalInformation?.familyName}
        />
        <DateInput
          fieldsName="dateOfdBirth"
          list=""
          date={state.PersonalInformation?.birthDate}
          
          maxDate={moment().subtract(18, "years")._d}
          onChange={(e) => {
            setPersonalInformationUpdateData({
              ...PersonalInformationUpdateData,
              birthDate: e, // التحديث هنا
            });
          }}
          disabled={shouldDisableFields}
          showValidationMessage={
            state.ApplicationInformationValidationPage
              ? state.ApplicationInformationValidationPage.includes(
                  "dateOfdBirth"
                )
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <AllDropDownsAHSF
          fieldsName="Gender"
          show={true}
          yesNo={true}
          disabled={shouldDisableFields}
          dropdownType="normal"
          arrayOoptionList={[
            { text: "ذكر", value: true },
            { text: "انثى", value: false },
          ]}
          KeyText={"text"}
          KeyValue={"value"}
          value={state.PersonalInformation?.gender}
          onChange={(e) => {
            //console.log(e.target.value, "sdsdddddd");
            updateOnCoNamesGender({
              gender: JSON.parse(e.target.value),
              phoneNumber: PersonalInformationUpdateData.mobilePhoneNumber,
              emailAddress: state.PersonalInformation?.emailAddress,
              aI_ApplicationInformationId: localStorage.getItem(
                "aI_ApplicationInformationId"
              ),
            });
            setPersonalInformationUpdateData({
              ...PersonalInformationUpdateData,
              gender: JSON.parse(e.target.value), // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ApplicationInformationValidationPage
              ? state.ApplicationInformationValidationPage.includes("Gender")
              : false
          }
          //showValidationMessage={true}
          validationMessage="يرجى تعبئة هذا الحقل"
        />

        <AllDropDownsAHSF
          fieldsName="Nationality"
          show={true}
          disabled={shouldDisableFields}
          dropdownType="normal"
          arrayOoptionList={state.AI_Nationality}
          KeyText={"aI_NationalityAr"}
          KeyValue={"aI_NationalityId"}
          defaultValue={state.PersonalInformation?.aI_NationalityId}
          onChange={(e) => {
            setPersonalInformationUpdateData({
              ...PersonalInformationUpdateData,
              aI_NationalityId: parseInt(e.target.value), // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ApplicationInformationValidationPage
              ? state.ApplicationInformationValidationPage.includes(
                  "Nationality"
                )
              : false
          }
          validationMessage="حقل اجباري"
        />
        <InputAHSF
          fieldsName="CellPhoneNumber"
          show={true}
          disabled={shouldDisableFields}
          type={"number"}
          defaultValue={state.PersonalInformation?.mobilePhoneNumber}
          onChange={(e) => {
            setPersonalInformationUpdateData({
              ...PersonalInformationUpdateData,
              mobilePhoneNumber: e.target.value, // التحديث هنا
            });
          }}
          onBlur={(e) => {
            updateOnCoNamesGender({
              gender: PersonalInformationUpdateData.gender,
              phoneNumber: e.target.value,
              emailAddress: state.PersonalInformation?.emailAddress,
              aI_ApplicationInformationId: localStorage.getItem(
                "aI_ApplicationInformationId"
              ),
            });
          }}
          showValidationMessage={
            state.ApplicationInformationValidationPage
              ? state.ApplicationInformationValidationPage.includes(
                  "CellPhoneNumber"
                )
              : false
          }
          validationMessage="حقل اجباري"
        />

        <AllDropDownsAHSF
          fieldsName="CountryOfResidence"
          show={true}
          disabled={shouldDisableFields}
          dropdownType="normal"
          arrayOoptionList={state.AI_CountryOfResidence}
          KeyText={"countryOfResidenceAr"}
          KeyValue={"aI_CountryOfResidenceId"}
          defaultValue={state.PersonalInformation?.aI_CountryOfResidenceId}
          onChange={(e) => {
            setPersonalInformationUpdateData({
              ...PersonalInformationUpdateData,
              aI_CountryOfResidenceId: parseInt(e.target.value),
              aI_GovernorateId: null,
              // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ApplicationInformationValidationPage
              ? state.ApplicationInformationValidationPage.includes(
                  "CountryOfResidence"
                )
              : false
          }
          validationMessage="حقل اجباري"
        />
        {/* {state.PersonalInformation?.aI_CountryOfResidenceId == 1 ? ( */}
    

    {
      state.AI_Governorate?
      <AllDropDownsAHSF
          fieldsName="city"
          show={true}
          disabled={shouldDisableFields}
          dropdownType="normal"
          arrayOoptionList={state.AI_Governorate}
          KeyText={"aI_GovernorateAr"}
          KeyValue={"aI_GovernorateId"}
          defaultValue={state.PersonalInformation?.aI_GovernorateId}
          onChange={(e) => {
            setPersonalInformationUpdateData({
              ...PersonalInformationUpdateData,
              aI_GovernorateId: parseInt(e.target.value), // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ApplicationInformationValidationPage
              ? state.ApplicationInformationValidationPage.includes("city")
              : false
          }
        />
      :<></>
    }
        
        {/* ) : (
          ""
        )} */}
        <InputAHSF
          fieldsName="email"
          type={"email"}
          show={true}
          disabled={true}
          defaultValue={state.PersonalInformation?.emailAddress}
        />
      </div>
    </>
  );
//to render html after loding ends
  return !state.PersonalInformationLoading &&

    !state.loadingAI_Governorate &&
    !state.loadingAI_CountryOfResidence ? (
    <>{html} </>
  ) : (
    ""
  );
};

export default PersonalInformation;
